import React from 'react';
import { galleryImages } from '../mock';

const Gallery = () => {
  return (
    <section className="py-32 px-6 bg-background border-t border-border/40">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-24">
          <h2 className="text-5xl md:text-6xl font-serif font-normal text-primary mb-6 tracking-wide">
            Ételgalériánk
          </h2>
          <div className="h-px w-12 bg-accent mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="relative aspect-square overflow-hidden"
            >
              <img 
                src={image}
                alt={`Étel ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
